
import HomePage from '../pages/home.f7.html';
import MyMitsuPage from '../pages/my-mitsu.f7.html';
import AboutPage from '../pages/about.f7.html';
import FormPage from '../pages/form.f7.html';
import NewsPage from '../pages/news.f7.html';
import ArticlePage from '../pages/article.f7.html';
import LocationPage from '../pages/location.f7.html';
import ContractPage from '../pages/contract.f7.html';
import NotificationsPage from '../pages/notifications.f7.html';
import AccountPage from '../pages/account.f7.html';
import RequestPage from '../pages/request.f7.html';
import HistoryPage from '../pages/history.f7.html';
import RequestDetailsPage from '../pages/request-details.f7.html';
import EditProfilePage from '../pages/edit-profile.f7.html';
import ChangePasswordPage from '../pages/change-password.f7.html';

import DynamicRoutePage from '../pages/dynamic-route.f7.html';
import RequestAndLoad from '../pages/request-and-load.f7.html';
import RequestAccessPage from '../pages/request-access.f7.html';
import AddLocationPage from '../pages/add-location.f7.html';

import ManageEquipmentsPage from '../pages/manage-equipments.f7.html';

import AdjustLocationPage from '../pages/adjust-location.f7.html';

import ManageConsentPage from '../pages/manage-consent.f7.html';

import GuestNewsPage from '../pages/guest-news.f7.html';
import ProfilePicturePage from '../pages/profile-picture.f7.html';

import NotFoundPage from '../pages/404.f7.html';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/my-mitsu/',
    component: MyMitsuPage,
  },
  {
    path: '/account-panel/',
    // panel: {
      component: AccountPage,
      //swipe: true,
    // },
  },
  {
    path: '/about/',
    component: AboutPage,
  },
  {
    path: '/form/',
    component: FormPage,
  },
  {
    path: '/news/',
    component: NewsPage,
  },
  {
    path: '/article/',
    component: ArticlePage,
  },
  {
    path: '/location/',
    component: LocationPage,
  },
  {
    path: '/manage-equipments/',
    component: ManageEquipmentsPage,
  },
  {
    path: '/contract/',
    component: ContractPage,
  },
  {
    path: '/notifications/',
    component: NotificationsPage,
  },
  {
    path: '/account/',
    component: AccountPage,
  },
  {
    path: '/request-repair/',
    component: RequestPage,
    alias: '/request-repair/:locationId/:unitId/',
  },
  {
    path: '/history/',
    component: HistoryPage,
  },
  {
    path: '/request-details/',
    component: RequestDetailsPage,
  },
  {
    path: '/edit-profile/',
    component: EditProfilePage,
  },
  {
    path: '/change-password/',
    component: ChangePasswordPage,
  },
  {
    path: '/request-access/',
    component: RequestAccessPage,
  },
  {
    path: '/add-location/',
    component: AddLocationPage,
  },

  {
    path: '/adjust-location/',
    component: AdjustLocationPage,
  },
  {
    path: '/manage-consent/',
    component: ManageConsentPage,
  },
  {
    path: '/guest-news/',
    component: GuestNewsPage,
  },
  {
    path: '/profile-picture/',
    component: ProfilePicturePage,
  },

  {
    path: '/dynamic-route/blog/:blogId/post/:postId/',
    component: DynamicRoutePage,
  },
  {
    path: '/request-and-load/user/:userId/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      app.preloader.show();

      // User ID from request
      var userId = routeTo.params.userId;

      // Simulate Ajax Request
      setTimeout(function () {
        // We got user data from request
        var user = {
          firstName: 'Vladimir',
          lastName: 'Kharlampidi',
          about: 'Hello, i am creator of Framework7! Hope you like it!',
          links: [
            {
              title: 'Framework7 Website',
              url: 'http://framework7.io',
            },
            {
              title: 'Framework7 Forum',
              url: 'http://forum.framework7.io',
            },
          ]
        };
        // Hide Preloader
        app.preloader.hide();

        // Resolve route to load page
        resolve(
          {
            component: RequestAndLoad,
          },
          {
            context: {
              user: user,
            }
          }
        );
      }, 1000);
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
